'use client';

import { FC } from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { Grid } from '@purpur/library';

import { BlockContentType } from '../../models/Content';
import { getBlockId } from '../../utils/content';
import { BlockHeader } from '../common/BlockHeader';
import { BlockContentSection, BlockContentStandaloneContainer } from './BlockContent.styles';
import { ContentCard } from './ContentCard';
import { transformBlockContent } from './transformers';

type Props = {
    contentItem: BlockContentType;
};

export const BlockContent: FC<Props> = ({ contentItem: initialContentItem }) => {
    const contentItem = useContentfulLiveUpdates(initialContentItem);

    const { backgroundColor, isHeaderNegative, blockTitle, blockCta, cards } = transformBlockContent(contentItem);

    return (
        <BlockContentSection
            $backgroundVariant={backgroundColor}
            data-section="Content Card Block"
            data-section-name={blockTitle}
            data-section-color-option={backgroundColor}
            id={getBlockId(contentItem)}
        >
            {(blockTitle || blockCta) && (
                <Grid noGap={true}>
                    <BlockHeader title={blockTitle} cta={blockCta} isNegative={isHeaderNegative} />
                </Grid>
            )}
            <BlockContentStandaloneContainer>
                {cards.map((card) => (
                    <ContentCard key={card.id} card={card} headingTag={blockTitle ? 'h3' : 'h2'} />
                ))}
            </BlockContentStandaloneContainer>
        </BlockContentSection>
    );
};
